import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Tour Packages',
        content: 'Discover tour packages designed for experiences, whether you’re after adventure, relaxation, or cultural.',
        paragraphs: [
            'Our curated tour packages offer a seamless travel experience, covering transportation, accommodation, guided tours, and unique local activities.',
            'With options for solo travelers, couples, families, and groups, we ensure every itinerary is crafted to match your interests, budget, and travel aspirations.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Customizable itineraries to fit your preferences',
            'Inclusive packages covering transport & lodging',
            'Experienced tour coordinators and local guides',
            'Flexible departure dates and group sizes',
            'Exclusive access to offbeat destinations and experiences'
        ],
        process: [
            'Select a tour category (Adventure, Cultural, Relaxation, etc.)',
            'Customize your itinerary and services',
            'Receive a detailed travel plan and booking confirmation',
            'Enjoy a hassle-free journey with on-ground support',
            'Share feedback and get personalized future recommendations'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I customize my tour package?',
                content: 'Absolutely! Our travel consultants will work with you to tailor the itinerary according to your preferences and budget.'
            },
            {
                id: 2,
                heading: 'Are flights included in the packages?',
                content: 'Flights can be included upon request. We offer packages with and without flight options based on your needs.'
            },
            {
                id: 3,
                heading: 'What is the group size for tours?',
                content: 'Group sizes vary depending on the package, but we also offer private tours for a more personalized experience.'
            },
            {
                id: 4,
                heading: 'Do you offer international tour packages?',
                content: 'Yes, we offer both domestic and international tour packages across popular and offbeat destinations.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Hotel Booking',
        content: 'Book from hotels, resorts, at prices, with options to match your travel and budget.',
        paragraphs: [
            'Our hotel booking service connects you with a network of verified accommodations worldwide, ensuring comfort, convenience, and great value during your stay.',
            'Whether you seek luxury resorts, budget-friendly inns, or unique boutique stays, we provide comprehensive booking support and exclusive deals.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Access to thousands of hotels globally',
            'Competitive pricing with special discounts',
            'Flexible booking and cancellation policies',
            'Detailed reviews and ratings for informed choices',
            '24/7 customer support for booking assistance'
        ],
        process: [
            'Search hotels by destination, dates, and preferences',
            'Compare amenities, prices, and guest reviews',
            'Select your preferred hotel and room type',
            'Confirm your booking with instant confirmation',
            'Receive your booking voucher and travel assistance'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I cancel or modify my hotel booking?',
                content: 'Yes, many hotels offer free cancellation or flexible modification options. Please check the cancellation policy before booking.'
            },
            {
                id: 2,
                heading: 'Are there discounts for group bookings?',
                content: 'Absolutely! We offer special rates and packages for group or corporate bookings. Contact us for tailored deals.'
            },
            {
                id: 3,
                heading: 'Is breakfast included in hotel bookings?',
                content: 'Some hotel rates include breakfast while others don’t. You can filter and select based on meal preferences during booking.'
            },
            {
                id: 4,
                heading: 'How do I know if a hotel is safe and verified?',
                content: 'We list only verified hotels with authentic guest reviews, star ratings, and clear safety and hygiene protocols.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Flight Booking',
        content: 'Book flights with ease, compare fares, and enjoy deals through our flight booking service.',
        paragraphs: [
            'Our platform connects you with leading airlines, offering real-time availability, competitive prices, and seamless ticketing for a smooth travel experience.',
            'Whether it’s a last-minute trip or a planned vacation, we ensure you find the best flights tailored to your schedule and budget.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Search and compare flights from multiple airlines',
            'Best price guarantee with special offers',
            'Flexible date and fare options',
            'Instant e-ticket confirmation',
            'Dedicated support for changes and cancellations'
        ],
        process: [
            'Enter your departure and destination cities, dates, and passenger details',
            'Browse available flights and compare fares and timings',
            'Select your preferred flight and seat class',
            'Proceed to secure payment and receive your e-ticket',
            'Access flight status updates and travel reminders'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I book multi-city or round-trip flights?',
                content: 'Yes, our system allows you to book one-way, round-trip, and multi-city flights with ease.'
            },
            {
                id: 2,
                heading: 'How do I receive my flight ticket?',
                content: 'Once the booking is complete, an e-ticket will be emailed to you instantly with all flight details.'
            },
            {
                id: 3,
                heading: 'What if I need to cancel or change my flight?',
                content: 'Cancellation and rescheduling policies depend on the airline. Our support team will assist you with any changes as per the airline’s terms.'
            },
            {
                id: 4,
                heading: 'Do you offer special discounts on flights?',
                content: 'Yes, we regularly offer promotions, early bird discounts, and group fare deals on selected routes and airlines.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Airport Transfers',
        content: 'Enjoy car services, airport pickups and transfers, with vehicles to suit your needs.',
        paragraphs: [
            'Our car rental services offer you the freedom to explore at your own pace, with options ranging from budget-friendly cars to luxury vehicles and chauffeur-driven rides.',
            'Whether you need a short airport transfer or a long-term car rental for your trip, we ensure a comfortable, safe, and hassle-free experience.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Wide selection of vehicles (Sedans, SUVs, Vans, Luxury Cars)',
            'Airport pickup & drop-off services',
            'Flexible rental durations (hourly, daily, weekly)',
            'Professional drivers and self-drive options',
            'Transparent pricing with no hidden charges'
        ],
        process: [
            'Choose your pickup location, date, and vehicle type',
            'Select self-drive or chauffeur-driven option',
            'Confirm booking with instant availability',
            'Receive vehicle/driver details prior to your trip',
            'Enjoy your ride with on-trip support and assistance'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I rent a car with a driver?',
                content: 'Yes, we offer chauffeur-driven car rentals for city tours, airport transfers, and outstation trips.'
            },
            {
                id: 2,
                heading: 'Do you provide self-drive car rentals?',
                content: 'Absolutely! You can choose from a range of self-drive cars, subject to license verification and security deposit.'
            },
            {
                id: 3,
                heading: 'Is fuel included in the rental price?',
                content: 'For self-drive rentals, fuel is usually not included. For chauffeur-driven services, fuel costs are typically covered.'
            },
            {
                id: 4,
                heading: 'How do I find my driver at the airport?',
                content: 'Our drivers will be waiting at the arrivals with a placard bearing your name. You’ll also receive driver contact details prior to pickup.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Visa Assistance',
        content: 'Your travel with our visa assistance, ensuring a process for tourist, business, and student visas.',
        paragraphs: [
            'We provide end-to-end support for visa applications, from documentation guidance to appointment scheduling, making international travel hassle-free.',
            'Our team stays updated with the latest embassy regulations to maximize approval chances and minimize delays.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Comprehensive visa application support',
            'Assistance with document preparation and verification',
            'Appointment scheduling with embassies/consulates',
            'Up-to-date information on visa policies and procedures',
            'Support for tourist, business, student, and transit visas'
        ],
        process: [
            'Select your destination and visa type',
            'Submit necessary documents and application details',
            'Our experts review and guide on required paperwork',
            'Schedule visa appointments and biometrics (if needed)',
            'Receive visa status updates and collect your visa'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Which types of visas do you assist with?',
                content: 'We provide assistance for tourist, business, student, transit, and other visa categories based on your travel purpose.'
            },
            {
                id: 2,
                heading: 'Do you guarantee visa approval?',
                content: 'While we offer professional guidance to increase approval chances, final decisions rest with the respective embassies and consulates.'
            },
            {
                id: 3,
                heading: 'Can you help with urgent or express visa applications?',
                content: 'Yes, we can assist with expedited visa applications where embassies offer express processing services.'
            },
            {
                id: 4,
                heading: 'What documents are typically required for a visa application?',
                content: 'Common documents include passport, photographs, financial statements, travel itinerary, invitation letters (if applicable), and completed application forms. Requirements vary by destination.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Travel Insurance',
        content: 'Secure your trip from unforeseen events with travel insurance covering medical and trip cancellations.',
        paragraphs: [
            'Our travel insurance services provide peace of mind, ensuring you’re covered against unexpected expenses like medical emergencies, lost baggage, or travel delays.',
            'We offer a range of insurance plans tailored to your travel needs, whether it’s a short getaway, business trip, or extended vacation abroad.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Coverage for medical emergencies and hospitalization',
            'Protection against trip cancellations and delays',
            'Baggage loss and personal belongings coverage',
            'Emergency evacuation and repatriation services',
            '24/7 global assistance and claim support'
        ],
        process: [
            'Choose a travel insurance plan based on your trip duration and needs',
            'Fill out basic traveler and trip information',
            'Review coverage details and premium amount',
            'Proceed to secure payment and receive your policy instantly',
            'Enjoy your trip with the assurance of global protection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Is travel insurance mandatory for international trips?',
                content: 'Some countries require valid travel insurance for visa issuance. Even if not mandatory, it is highly recommended for safety and peace of mind.'
            },
            {
                id: 2,
                heading: 'What is covered under travel insurance?',
                content: 'Coverage typically includes medical emergencies, trip cancellations, travel delays, baggage loss, and accidental injuries. Plan benefits may vary.'
            },
            {
                id: 3,
                heading: 'Can I purchase travel insurance for domestic trips?',
                content: 'Yes, we offer travel insurance plans for both domestic and international journeys.'
            },
            {
                id: 4,
                heading: 'How do I file a claim in case of an emergency?',
                content: 'You can contact our 24/7 assistance helpline to initiate a claim. We will guide you through the documentation and claim process promptly.'
            }
        ]
    }

];

export default services;